import { render, staticRenderFns } from "./automaticAllocationConfig.vue?vue&type=template&id=f0914810&"
import script from "./automaticAllocationConfig.vue?vue&type=script&lang=js&"
export * from "./automaticAllocationConfig.vue?vue&type=script&lang=js&"
import style0 from "./automaticAllocationConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0914810')) {
      api.createRecord('f0914810', component.options)
    } else {
      api.reload('f0914810', component.options)
    }
    module.hot.accept("./automaticAllocationConfig.vue?vue&type=template&id=f0914810&", function () {
      api.rerender('f0914810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/automaticAllocationConfig.vue"
export default component.exports